import * as React from 'react';
import * as vars from '../../../consts/variables';
import { __ } from '../../../helpers/TranslationService';
import { IWebcam } from '../../../interfaces/IShipLivePosition';

const styles: Record<string, React.CSSProperties> = {
    webcam: {
        position: 'relative',
        marginBottom: 10,
        display: 'flex',
    },
    title: {
        textAlign: 'center',
        fontSize: 18,
        marginTop: 30,
        marginBottom: 15,
    },
    webcamImage: {
        width: '100%',
        height: 230,
    },
    webcamTitleBackground: {
        backgroundColor: 'rgba(7, 73, 111, 0.8)',
        height: 40,
        bottom: 0,
        left: 0,
        width: '100%',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    webcamTitle: {
        color: vars.white,
        fontSize: 15,
        fontWeight: 'bold',
    },
};

type IWebcamProps = IWebcam & { shipTitle: string };

export function Webcam(props: IWebcamProps) {
    const imgDescription = `${__('%s webcams (ship page)', 'dreamlines', props.shipTitle)} ${__(
        props.title,
        'dreamlines',
    )}`;
    return (
        <div style={styles.webcam}>
            <img
                style={styles.webcamImage}
                src={`data:image/jpeg;base64, ${props.webCamBase64Data}`}
                alt={imgDescription}
            />
            <div style={styles.webcamTitleBackground}>
                <span style={styles.webcamTitle}>{__(props.title, 'dreamlines')}</span>
            </div>
        </div>
    );
}

interface IProps {
    shipTitle: string;
    webcams: IWebcam[];
}

export function Webcams({ shipTitle, webcams }: IProps) {
    return (
        webcams.length > 0 && (
            <div>
                <h2 style={styles.title}>
                    {__('%s webcams (ship page)', 'dreamlines', shipTitle)}
                </h2>
                <div>
                    {webcams.map((webcam, index) => (
                        <Webcam key={index} {...webcam} shipTitle={shipTitle} />
                    ))}
                </div>
            </div>
        )
    );
}
